import { supabase } from '../supabaseClient'

export const DEFAULT_TAG_REFERENCE_TABLE = {
  html: {
    fields: ['function', 'html', 'firingTriggerId', 'tag_id', 'name'],
    ignore: false,
  },
  ua: {
    fields: ['function', 'trackingId', 'firingTriggerId', 'tag_id', 'name'],
    ignore: false,
  },
}

export function parseGtmValue(val) {
  if (Array.isArray(val)) {
    if (
      val.length === 2 &&
      typeof val[0] === 'string' &&
      Array.isArray(val[1])
    ) {
      const [firstKey, arr] = val
      const obj = { [firstKey]: parseGtmValue(arr[0]) }
      for (let i = 1; i < arr.length; i += 2) {
        obj[arr[i]] = parseGtmValue(arr[i + 1])
      }
      return obj
    }
    return val.map((item) => parseGtmValue(item))
  }

  if (val && typeof val === 'object') {
    const obj = {}
    Object.entries(val).forEach(([k, v]) => {
      obj[k] = parseGtmValue(v)
    })
    return obj
  }

  if (typeof val === 'string' && val.includes(',')) {
    const parts = val.split(',')
    if (parts.length % 2 === 0) {
      const obj = {}
      for (let i = 0; i < parts.length; i += 2) {
        obj[parts[i]] = parseGtmValue(parts[i + 1])
      }
      return obj
    }
  }

  if (val === 'true') return true
  if (val === 'false') return false
  return val
}

export function getNestedValue(obj, path) {
  return path
    .split('.')
    .reduce((acc, part) => {
      if (acc === undefined || acc === null) return undefined
      const next = acc[part]
      return parseGtmValue(next)
    }, obj)
}

export function setNestedValue(obj, path, value) {
  const parts = path.split('.')
  let current = obj
  for (let i = 0; i < parts.length - 1; i++) {
    if (typeof current[parts[i]] !== 'object' || current[parts[i]] === null) {
      current[parts[i]] = {}
    }
    current = current[parts[i]]
  }
  current[parts[parts.length - 1]] = value
}

export function collectNestedKeys(obj, prefix = '') {
  const keys = []
  Object.entries(obj || {}).forEach(([k, v]) => {
    const full = prefix ? `${prefix}.${k}` : k
    keys.push(full)
    const parsed = parseGtmValue(v)
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      keys.push(...collectNestedKeys(parsed, full))
    }
  })
  return keys
}

export async function fetchTagReference() {
  const { data, error } = await supabase
    .from('gtm_tag_reference')
    .select('function, fields, ignore')

  if (error || !data) {
    return DEFAULT_TAG_REFERENCE_TABLE
  }

  const ref = {}
  data.forEach((row) => {
    const fields = Array.isArray(row.fields)
      ? row.fields.map((f) => {
          if (typeof f === 'string') {
            return { key: f, passthrough: true, mapTo: f }
          }
          return f
        })
      : []
    ref[row.function] = { fields, ignore: row.ignore || false }
  })
  return Object.keys(ref).length ? ref : DEFAULT_TAG_REFERENCE_TABLE
}

export function cleanGtmTags(tags, reference = DEFAULT_TAG_REFERENCE_TABLE) {
  return tags.flatMap((tag) => {
    const cfg = reference[tag.function]
    if (!cfg) return [tag]
    if (cfg.ignore) return []
    const keep = cfg.fields || []
    const cleaned = {}
    keep.forEach((item) => {
      if (typeof item === 'string') {
        const val = getNestedValue(tag, item)
        if (val !== undefined) setNestedValue(cleaned, item, val)
      } else if (item && item.key) {
        const val = getNestedValue(tag, item.key)
        if (val === undefined) return
        const dest = item.mapTo || item.key
        const finalVal = item.passthrough === false ? item.value : val
        setNestedValue(cleaned, dest, finalVal)
      }
    })
    return [cleaned]
  })
}
